import type {ReactNode} from 'react';
import {cn} from '../lib/cn';

export type InfoBoxProps = {
  className?: string;
  children: ReactNode;
};

export function InfoBox({className, children}: InfoBoxProps) {
  return (
    <div
      className={cn(
        'rounded-lg border border-blue-200 bg-blue-50 p-4 text-blue-900 [&_svg]:h-5 [&_svg]:w-5 [&_svg]:text-blue-600',
        className,
      )}
    >
      {children}
    </div>
  );
}
